/**
 * Meridional contour chart (r–z plane).
 * Shows multiple construction lines (HUB…SHROUD) in a static Plotly chart.
 * Supports zoom and pan.
 */
import Plot from "react-plotly.js";
import { useChartColors } from "../../chartTheme";

export default function MeridContour({ lines = [] }) {
  const { LINE_COLORS } = useChartColors();
  const traces = lines.map((l, i) => {
    const color = l.color ?? LINE_COLORS[i % LINE_COLORS.length];
    return {
    type: "scatter",
    mode: "lines+markers",
    name: l.name,
    x: l.r,
    y: l.z,
    line: { color, width: 2 },
    marker: {
      size: 4,
      color,
    },
    hovertemplate: `${l.name}<br>r=%{x:.2f} mm  z=%{y:.2f} mm<extra></extra>`,
  };});

  return (
    <Plot
      data={traces}
      layout={{
        margin: { l: 55, r: 14, t: 10, b: 45 },
        xaxis: { title: "r [mm]", gridcolor: "#e5e7eb", linecolor: "#d1d5db", tickcolor: "#9ca3af", tickfont: { size: 10 }, zeroline: false, showspikes: true, spikemode: "across", spikecolor: "#9ca3af", spikethickness: 1, spikedash: "dot" },
        yaxis: { title: "z [mm]", gridcolor: "#e5e7eb", linecolor: "#d1d5db", tickcolor: "#9ca3af", tickfont: { size: 10 }, zeroline: false, showspikes: true, spikemode: "across", spikecolor: "#9ca3af", spikethickness: 1, spikedash: "dot", scaleanchor: "x", scaleratio: 1 },
        paper_bgcolor: "transparent",
        plot_bgcolor: "#f9fafb",
        hovermode: "closest",
        showlegend: false,
        dragmode: "pan",
      }}
      config={{
        displayModeBar: "hover",
        modeBarButtons: [["zoom2d", "pan2d", "autoScale2d", "resetScale2d", "toImage"]],
        modeBarButtonsToRemove: ["select2d", "lasso2d"],
        scrollZoom: true,
        responsive: true,
        displaylogo: false,
      }}
      style={{ width: "100%", height: "100%" }}
      useResizeHandler
    />
  );
}
